import React from 'react';
import { Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './ActionConfirmDialog.css';
import PropTypes from 'prop-types';

const ActionConfirmDialog = ({
    open,
    onClose,
    title,
    message1,
    message2,
    actionText,
    onAction,
    actionIcon
}) => {
    return (
        <>
            {open && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        zIndex: 1300,
                        background: 'rgba(0,0,0,0.5)',
                        
                        pointerEvents: 'none',
                    }}
                />
            )}
            <Dialog
                open={open}
                onClose={(event, reason) => {
                    // Only close on explicit cancel button click, not backdrop click
                    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                        onClose();
                    }
                }}
                aria-labelledby="confirm-dialog-title"
                PaperProps={{ style: { backgroundColor: 'transparent' } }}
                hideBackdrop
                disableEscapeKeyDown
            >
                <div className="dialog-content" onMouseDown={(e) => e.stopPropagation()}>
                    <div className="dialog-header">
                        <h2 id="confirm-dialog-title" className="dialog-title">{title}</h2>
                        <IconButton onClick={onClose} className="dialog-close-button">
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <div className="dialog-body">
                        <p className="dialog-message">{message1}</p>
                        <p className="dialog-message">{message2}</p>
                    </div>
                    <div className="dialog-actions">
                        <button onClick={onClose} className="dialog-cancel-button">
                            Cancel
                        </button>
                        <button onClick={onAction} className="dialog-action-button">
                            {actionText}
                            {actionIcon && <img src={actionIcon} alt="" className="dialog-action-icon" />}
                        </button>
                    </div>
                </div>
            </Dialog>
        </>
    );
};

ActionConfirmDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    message1: PropTypes.string,
    message2: PropTypes.string,
    actionText: PropTypes.string.isRequired,
    onAction: PropTypes.func.isRequired,
    actionIcon: PropTypes.string,
};

export default ActionConfirmDialog; 